import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tippy = _resolveDirective("tippy")!

  return (!_ctx.container.isActive && _ctx.enableStale)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Stale"))
    : _withDirectives((_openBlock(), _createElementBlock("span", {
        key: 1,
        class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-700", _ctx.yardStatusBackgroundClasses[_ctx.container.yardStatus]])
      }, [
        _createTextVNode(_toDisplayString(_ctx.getYardStatusLabelText()), 1)
      ], 2)), [
        [_directive_tippy, _ctx.getYardStatusTooltipText()]
      ])
}